import RegistrationSuccessView from "views/RegistrationSuccessView/RegistrationSuccessView";

export default RegistrationSuccessView;